import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable as _httpsCallable } from 'firebase/functions';

const httpsCallable = <T, U>(name: string) => _httpsCallable<T, U>(getFunctions(getApp(), 'asia-northeast1'), name);

export { httpsCallable };
